import { createTheme } from '@mui/material/styles';

const darkTheme = createTheme({
  palette: {
    mode: 'dark', // Enables dark mode
    primary: {
      main: '#6871d1', // Brand primary color
    },
    secondary: {
      main: '#2d2e48', // Brand secondary color
    },
    background: {
      default: '#1e1e2f', // Brand background
      paper: '#2b2c3e', // Card/paper background
    },
    text: {
      primary: '#fff',
      secondary: '#aaa',
    },
  },
  typography: {
    fontFamily: "'Lato', sans-serif",
    allVariants: {
      fontFamily: "'Lato', sans-serif",
    },
  },
});

export default darkTheme;
